import React, { Component } from 'react'
import StagesManager from '../../../StagesManager'
import PhotoMedia from './PhotoMedia'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../../../stores/actionsList'
import VideoMedia from './VideoMedia'
import FileMedia from './FileMedia'
import { checkTranslation, translate } from '../../../../utils/useful'
class ContactMedia extends Component {
    state = {
        medias: [
            { name: '{{lang}}messenger.Photos', icon: "/assets/icons/camera-blue.svg", key: 'image' },
            { name: '{{lang}}messenger.Video', icon: "/assets/icons/video-blue.svg", key: 'video' },
            { name: '{{lang}}messenger.File', icon: "/assets/icons/doc-blue.svg", key: 'file' },
            { name: '{{lang}}messenger.Music', icon: "/assets/icons/music-blue.svg", key: 'music' },
            { name: '{{lang}}messenger.Voice', icon: "/assets/icons/mic-blue.svg", key: 'voice' },
            { name: '{{lang}}messenger.Links', icon: "/assets/icons/link-blue.svg", key: 'links' },
        ],
        currentPage: 'image',
    }
    componentDidMount() { }

    changePage = (prop) => {
        this.setState({ currentPage: prop.key })
        this.stageManager.changeStage(prop.key)
    }

    render() {
        return (
            <div className='h-100 w-100'>
                <div className='px-2 flexc' style={{ height: '60px', borderBottom: "1px solid #eee" }}>
                    <button className='flexc' onClick={() => this.props.changeStage('')}>
                        <img width={20} src='/assets/icons/angle-right-black.svg' className='rtl-button' style={{ transform: 'rotate(180deg)' }} />
                        <p className='text-bold text-small px-1'>{translate('messenger.Media')}</p>
                    </button>
                </div>
                <div className='w-100' style={{ height: '40px' }}>
                    <div className='flexcb w-100 px-3 py-1' style={{}}>
                        {Array.isArray(this.props.medias) && this.props.medias.map((prop, index) => {
                            if (this.props.media[prop.key] && this.props.media[prop.key].length > 0) {
                                return (
                                    <button key={index} className={'flexcc pt-2 pb-1 ' + (this.state.currentPage == prop.key ? ' selected main-cb bb-blue ' : ' main-c4 unselected bb-none')} onClick={() => this.changePage(prop)}>
                                        {/* <img width={18} src={prop.icon} /> */}
                                        <p className=''>{checkTranslation(prop.name)}</p>
                                    </button>
                                )
                            }
                        })}
                    </div>
                </div>
                {/* } */}
                <div className='w-100 scroll-no-scrollbar' style={{ height: 'calc(100% - 100px)' }}>
                    <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true} >
                        <PhotoMedia messenger={this.props.messenger} width={this.props.width} media={this.props.media} filterMedia={this.props.filterMedia} stage={0} stageName={'image'} colors={this.props.colors} />
                        <VideoMedia messenger={this.props.messenger} width={this.props.width} media={this.props.media} filterMedia={this.props.filterMedia} stage={1} stageName={'video'} colors={this.props.colors} />
                        <FileMedia messenger={this.props.messenger} width={this.props.width} media={this.props.media} filterMedia={this.props.filterMedia} stage={1} stageName={'file'} colors={this.props.colors} />
                    </StagesManager>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => ({ settings: state.settings, user: state.user, messengers: state.messengers })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContactMedia);
